import React, { memo } from "react";
import PropTypes from "prop-types";
import Row from "../../../../../Common/Row";
import Table from "../../../../../Common/Table";

const Rows = memo(({ phone }) => {
	return (
		<>
			<Row label={`Phone`} value={phone.phone} />
			<Row label={`Type`} value={phone.type} />
		</>
	);
});

const Phone = memo(({ phone }) => {
	return (
		<Table
			title={`Phone details - ${phone.type}`}
			preferred={Boolean(phone.isPreferred)}
			iconHoverText={`Preferred`}
		>
			<Rows phone={phone} />
		</Table>
	);
});
Phone.displayName = `Phone`;
Phone.propTypes = {
	phone: PropTypes.object.isRequired
};
Rows.displayName = `Rows`;
Rows.propTypes = {
	phone: PropTypes.object.isRequired
};
export default Phone;
